import { render, staticRenderFns } from "./AeIdenticon.vue?vue&type=template&id=6988ca95&scoped=true"
import script from "./AeIdenticon.vue?vue&type=script&lang=js"
export * from "./AeIdenticon.vue?vue&type=script&lang=js"
import style0 from "./AeIdenticon.vue?vue&type=style&index=0&id=6988ca95&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6988ca95",
  null
  
)

export default component.exports